import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-text-customfield',
  templateUrl: './text-customfield.component.html',
  styleUrls: ['./text-customfield.component.scss']
})
export class TextCustomfieldComponent {
  @Input() hint: string;
  @Input() label: string;
  @Input() valueController: FormGroup;

  // autoResize(event: Event) {
  //   const textarea = event.target as HTMLTextAreaElement;
  //   textarea.style.height = 'auto';
  //   textarea.style.height = textarea.scrollHeight + 'px';
  // }
}
